import { render, staticRenderFns } from "./DavichbrandTxtBg.vue?vue&type=template&id=3b9d4e58&scoped=true&"
import script from "./DavichbrandTxtBg.vue?vue&type=script&lang=js&"
export * from "./DavichbrandTxtBg.vue?vue&type=script&lang=js&"
import style0 from "./DavichbrandTxtBg.vue?vue&type=style&index=0&id=3b9d4e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9d4e58",
  null
  
)

export default component.exports